/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_Ocr_PcInputs */

const en_pc_cmp_r_ocr_pc = /** @type {(inputs: Pc_Cmp_R_Ocr_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latin scripts only for now`)
};

const zh_pc_cmp_r_ocr_pc = /** @type {(inputs: Pc_Cmp_R_Ocr_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目前仅支持拉丁文字`)
};

/**
* | output |
* | --- |
* | "Latin scripts only for now" |
*
* @param {Pc_Cmp_R_Ocr_PcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_ocr_pc = /** @type {((inputs?: Pc_Cmp_R_Ocr_PcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_Ocr_PcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_ocr_pc(inputs)
	return zh_pc_cmp_r_ocr_pc(inputs)
});
export { pc_cmp_r_ocr_pc as "pc.cmp.r.ocr.pc" }